<template>
	<div :class="['side-menu hidden blue-gradient dark-transparent h-screen lg:flex flex-col fixed z-10 top-0 space-y-4']" @mouseOver="collapsed=false" @mouseOut="collapsed=true">
		<div class="w-full relative h-24 mb-4">
			<Logo class=" w-full mt-6 logo-collapsed absolute" :collapsed="true"/>
			<div class="bg-white dark:bg-bs-dark-bg -mx-2 px-5 py-3  logo-full h-full flex items-center">
				<Logo class="w-10/12 mx-auto" />
			</div>
		</div>
		<router-link active-class="menu-item-active"
			class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-3 py-3 w-full flex items-center justify-start" 
			to="/"
			v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.home.active : menuIcons.home.default" class="mr-4"  />
			<span class="menu-text">Dashboard</span>
		</router-link>
		<router-link active-class="menu-item-active"
		class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-3 py-3 w-full flex items-center justify-start border-0"
		to="/settings"
		v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.settings.active : menuIcons.settings.default" class="mr-4"  />
			<span class="menu-text">Settings</span>
		</router-link>
		<router-link active-class="menu-item-active"
		class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-3 py-3 w-full flex items-center justify-start border-0"
		to="/openclaw"
		v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.openclaw.active : menuIcons.openclaw.default" class="mr-4"  />
			<span class="menu-text">OpenClaw</span>
		</router-link>
		<!--CASH OUT-->
		<!-- <router-link active-class="menu-item-active" 
		class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-3 py-3 w-full flex items-center justify-start border-0" 
		to="/virtual-cashout"
		v-slot="{isActive }"
		>
			<img :src="(`@/assets/images/menu/${isActive ? 'wallet.selected' : 'wallet'}.svg`)" class="mr-4"  />
			<span class="menu-text">Cashout</span>
		</router-link> -->


		<div class="flex-grow" />

		<router-link active-class="menu-item-active"
		class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-3 py-3 w-full flex items-center justify-start border-0"
		to="/profile"
		v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.profile.active : menuIcons.profile.default" class="mr-4"  />
			<span class="menu-text">Profile</span>
		</router-link>

		<!--LOGOUT-->
		<a @click.prevent="onLogout" class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-3 py-3 w-full flex items-center justify-start border-0">
			<img :src="isActive ? menuIcons.logout.active : menuIcons.logout.default" class="mr-4"  />
			<span class="menu-text">Logout</span>
		</a>
		<!-- <div class="flex w-full text-right mt-auto py-3" @click="onToggle">
			<font-awesome-icon
				:icon="['fa', 'angle-double-right']"
				v-show="collapsed"
				class="text-white cursor-pointer mx-auto"
			/>
			<font-awesome-icon
				v-show="!collapsed"
				:icon="['fa', 'angle-double-left']"
				class="ml-auto text-white cursor-pointer"
			/>
		</div> -->
	</div>
</template>

<script>
import Logo from '../atoms/Logo.vue'
import firebase from '@/firebase'
import { mapState } from 'vuex'
import { menuIcons } from "@/commons/helpers"
export default {
	components: { Logo },
	data: function () {
		return {
			collapsed: true,
			menuIcons,
		}
	},
	computed: {
		...mapState(['isAdmin']),
	},
	methods: {
		onToggle: function () {
			this.collapsed = !this.collapsed
		},
		onLogout: function() {
			firebase.auth().signOut();
			this.$router.replace({ name: "Login" });
		},
	}

}
</script>

<style>
.menu-icon-glyph {
  display: inline-block;
  width: 1.5rem;
  margin-right: 1rem;
  text-align: center;
  font-size: 1.1rem;
}
.admin-section-divider {
  margin-top: 1rem;
  padding: 6px 14px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: rgba(255,255,255,0.5);
  border-top: 1px solid rgba(255,255,255,0.12);
  padding-top: 14px;
}
.admin-sub { font-size: 0.9rem; }
.side-menu {
  transition: all 0.2s ease-in-out;
  width: 4rem;
  @apply px-2;
}
.side-menu:hover {
  width: 16rem;
  box-shadow: 5px 0 20px 0 rgba(0,0,0,0.3)
}

.menu-text {
	transform: translate(-200px, 0);
	transition: opacity 0.1s ease-in-out;
	opacity:0;
}
.side-menu:hover .menu-text {
	transform: translate(0px, 0);
	transition: opacity 0.3s ease-in-out;
	opacity:1;	
}
.logo-collapsed { 
	opacity: 1; 
	transition: opacity 0.3s ease-in-out;  
}
.logo-full { 
	opacity: 0; 
	box-shadow: inset 0 -3px 6px -4px rgba(0,0,0,0.25);	
}
.side-menu:hover .logo-collapsed  {
	transition: all 0s ease-in-out;
	opacity: 0;
	
}
.side-menu:hover .logo-full  {
	opacity: 1
}
.menu-item-active {
	@apply bg-white font-medium text-bs-dark-bg dark:bg-bs-dark-bg-over	dark:text-white border-0;
}
</style>